import { Extension } from "@tiptap/core";

export const InlineMathIndentation = Extension.create({
  name: "inlineMathIndentation",

  addGlobalAttributes() {
    return [
      {
        types: ["paragraph"],
        attributes: {
          mathIndentation: {
            default: true,
            renderHTML: () => ({}),
          },
        },
      },
    ];
  },
});
